import store from "@/store";
import { LoaderType } from "@/store/modules/loader";

export const $loader = {
  loading: (type?: LoaderType): boolean => store.getters["loader/loading"](type),
  increment: (type?: LoaderType): void => store.commit("loader/increment", type),
  decrement: (type?: LoaderType): void => store.commit("loader/decrement", type),
};
